import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../../helper/ThemeToggleButton";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logout } from "../../store/reducers/auth/auth.reducer";

const NavHeader = ({
  sidebarActive,
  setSidebarActive,
  mobileMenu,
  setMobileMenu,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/sign-in");
  };

  return (
    <div className="navbar-header">
      <div className="row align-items-center justify-content-between">
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-4">
            <button
              type="button"
              className="sidebar-toggle"
              onClick={() => setSidebarActive(!sidebarActive)}
            >
              {sidebarActive ? (
                <Icon
                  icon="iconoir:arrow-right"
                  className="icon text-2xl non-active"
                />
              ) : (
                <Icon
                  icon="heroicons:bars-3-solid"
                  className="icon text-2xl non-active "
                />
              )}
            </button>
            <button
              onClick={() => setMobileMenu(!mobileMenu)}
              type="button"
              className="sidebar-mobile-toggle"
            >
              <Icon icon="heroicons:bars-3-solid" className="icon" />
            </button>
          </div>
        </div>
        <div className="col-auto">
          <div className="d-flex flex-wrap align-items-center gap-3">
            {/* ThemeToggleButton */}
            <ThemeToggleButton />

            <div className="dropdown">
              <button
                className="d-flex justify-content-center align-items-center rounded-circle"
                type="button"
                data-bs-toggle="dropdown"
              >
                <img
                  src="assets/images/user.png"
                  alt="image_user"
                  className="w-40-px h-40-px object-fit-cover rounded-circle"
                />
              </button>
              <div className="dropdown-menu to-top dropdown-menu-sm">
                <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                  <div>
                    <h6 className="text-lg text-primary-light fw-semibold mb-2">
                      {user.nombre_completo}
                    </h6>
                    <span className="text-secondary-light fw-medium text-sm">
                      {user.rol_display}
                    </span>
                  </div>
                  <button type="button" className="hover-text-danger">
                    <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                  </button>
                </div>
                <ul className="to-top-list">
                  <li>
                    <Link
                      className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                      to="/view-profile"
                    >
                      <Icon icon="solar:user-linear" className="icon text-xl" />{" "}
                      My Profile
                    </Link>
                  </li>
                  <li>
                    <button
                      className="dropdown-item text-black px-0 py-8 hover-text-danger d-flex align-items-center gap-3"
                      onClick={handleLogout}
                    >
                      <Icon icon="lucide:power" className="icon text-xl" />
                      Cerrar sesión
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            {/* Profile dropdown end */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavHeader;
